export enum Company {
	Index = 'company.index',
	Show = 'company.show',
	Create = 'company.create',
	Update = 'company.update',
	Delete = 'company.delete',
}
